import React from 'react';
import { Format } from 'devextreme/localization';
import dayjs from 'dayjs';

import { TValue } from 'types/columnDefs';

/* ======================================== */

type TProps = {
    value: TValue;
    format: Format | undefined;
};

/* ======================================== */

/**
 * @private
 */
export const CellDateTime: React.FC<TProps> = (props) => {
    const date = dayjs(props.value as Date);

    return (
        <span>
            {props.value && date.isValid() && date.valueOf() > 0
                ? date.format(props.format as string)
                : ''
            }
        </span>
    );
};
